import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledBottomImage = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
  ${props => props.theme.bottomImage}
`;

const BottomImage = ({url, altText}) => {
  if (!url || url.endsWith('/undefined')) {
    return null;
  }

  return <StyledBottomImage src={url} alt={altText || ''} />;
};

BottomImage.propTypes = {
  url: PropTypes.string,
  altText: PropTypes.string
};

export default BottomImage;
